// extracted by mini-css-extract-plugin
export var component = "BoxNavigation-module--component--W6AML";
export var header = "BoxNavigation-module--header--Ov1eo";
export var list = "BoxNavigation-module--list--3Or9t";
export var title = "BoxNavigation-module--title--v9jGe";
export var preamble = "BoxNavigation-module--preamble--15AAu";
export var body = "BoxNavigation-module--body--Nx+xx";
export var item = "BoxNavigation-module--item--pY7kW";
export var link = "BoxNavigation-module--link--5mGmU";